<template>
	<div class="ui segment ">
		<sui-dimmer :active="getLoading" inverted>
			<sui-loader content="Cargando..." />
		</sui-dimmer>
		<a
			v-show="!getCronometroFinalizo"
			class="ui  right ribbon label"
			:class="{ red: getEsTiempoDeEmpezar, blue: !getEsTiempoDeEmpezar }"
		>
			{{ getIndicador }}</a
		>
		<a v-show="getCronometroFinalizo" class="ui blue right ribbon label"
			>AHORA</a
		>
		<base-sidebar />
		<div class="ui grid">
			<div class="sixteen wide column">
				<slot />
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	computed: {
		...mapGetters('menu', ['isOpen'], ['isLoading']),
		...mapGetters('app', ['isLoading', 'getTitulo']),
		...mapGetters('oidc', ['oidcUser']),
		...mapGetters('indicadores', [
			'getIndicador',
			'getCronometroFinalizo',
			'getEsTiempoDeEmpezar'
		]),
		...mapGetters('examenAspirante', ['getLoading'])
	},
	mounted: function() {
		this.obtenerExamenAspirante({
			ficha: this.oidcUser.username,
			onComplete: (respose) => {
				const examenAspirante = respose.data.data;
				if (
					examenAspirante.areaDeConocimientoActual === '' &&
					examenAspirante.seccionActual === '' &&
					examenAspirante.preguntaActual === ''
				) {
					if (this.$router.currentRoute.name !== 'inicio') {
						this.$router.push('inicio');
					}
				} else if (
					examenAspirante.seccionActual === '' &&
					examenAspirante.preguntaActual === ''
				) {
					if (this.$router.currentRoute.name !== 'areaDeConocimiento') {
						this.$router.push('areaDeConocimiento');
					}
				} else if (examenAspirante.preguntaActual === '') {
					if (this.$router.currentRoute.name !== 'seccion') {
						this.$router.push('seccion');
					}
				} else {
					if (this.$router.currentRoute.name !== 'pregunta') {
						this.$router.push('pregunta');
					}
				}
			},
			onError: () => {
				this.$router.push('inicio');
			}
		});
	},
	methods: {
		...mapActions('examenAspirante', ['obtenerExamenAspirante'])
	}
};
</script>
